module.exports = __webpack_public_path__ + "img/logo.8057b1d1.jpg";